// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ================= HEADER ================= */
#header-wrap {
  background: #e5eef0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 999;
  width: 100%;
}
#header-wrap .nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 20px;
}
#header-wrap .nav-container nav {
  flex: 1 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* ================= MOBILE TOGGLE ================= */
}
#header-wrap .nav-container nav .nav-mobile {
  display: none;
}
#header-wrap .nav-container nav .nav-mobile button {
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
}
#header-wrap .nav-container nav .nav-mobile button span {
  width: 25px;
  height: 3px;
  background: #212121;
  display: block;
  position: relative;
  transition: 0.3s;
}
#header-wrap .nav-container nav .nav-mobile button span::before, #header-wrap .nav-container nav .nav-mobile button span::after {
  content: "";
  width: 100%;
  height: 3px;
  background: #212121;
  position: absolute;
  transition: 0.3s;
}
#header-wrap .nav-container nav .nav-mobile button span::before {
  top: -8px;
}
#header-wrap .nav-container nav .nav-mobile button span::after {
  bottom: -8px;
}
#header-wrap .nav-container nav .nav-mobile button.active span {
  background: transparent;
}
#header-wrap .nav-container nav .nav-mobile button.active span::before {
  transform: rotate(45deg);
  top: 0;
}
#header-wrap .nav-container nav .nav-mobile button.active span::after {
  transform: rotate(-45deg);
  bottom: 0;
}
#header-wrap .nav-container nav {
  /* ================= NAV LIST ================= */
}
#header-wrap .nav-container nav .nav-list {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0;
  padding: 0;
  flex: 1 1;
}
#header-wrap .nav-container nav .nav-list li {
  position: relative;
  white-space: nowrap;
}
#header-wrap .nav-container nav .nav-list li a {
  display: block;
  padding: 8px 10px;
  color: #212121;
  font-weight: 800;
  font-size: 15px;
  text-decoration: none;
  transition: 0.3s;
}
#header-wrap .nav-container nav .nav-list li a:hover {
  color: #CFAB8D;
}
#header-wrap .nav-container nav .nav-list li {
  /* ================= DROPDOWN ================= */
}
#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle > a::after {
  content: "▼";
  font-size: 10px;
  margin-left: 5px;
}
#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0%;
  min-width: 220px;
  background: white;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
}
#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a {
  padding: 12px 20px;
  font-weight: 600;
}
#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a:hover {
  background: #f5f5f5;
}
#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown.show {
  display: block;
}

/* ================= DESKTOP HOVER ONLY ================= */
@media (min-width: 1135px) {
  li.nav-dropdown-toggle:hover > a {
    color: #CFAB8D;
  }
  li.nav-dropdown-toggle:hover .navbar-dropdown {
    display: block;
  }
}
/* ================= MOBILE STYLES ================= */
@media (max-width: 1134px) {
  #header-wrap .nav-container nav .nav-mobile {
    display: flex;
  }
  #header-wrap .nav-container nav .nav-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  #header-wrap .nav-container nav .nav-list.open {
    max-height: 90vh;
    overflow-y: auto;
  }
  #header-wrap .nav-container nav .nav-list li {
    width: 100%;
    border-bottom: 1px solid #ddd;
  }
  #header-wrap .nav-container nav .nav-list li a {
    padding: 12px 20px;
  }
  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle > a::after {
    content: "";
  }
  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown {
    position: static;
    display: none;
    background: #f5f5f5;
    box-shadow: none;
    padding: 0;
  }
  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a {
    padding: 12px 40px;
  }
  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown.show {
    display: block;
  }
}
/* ================= SMALL DEVICES ================= */
@media (max-width: 768px) {
  #header-wrap .nav-container {
    padding: 12px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB,+CAAA;AAEA;EACE,mBANO;EAOP,wCAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AAJF;AAME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AAJJ;AAMI;EACE,SAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,sDAAA;AALN;AAOM;EACE,aAAA;AALR;AAOQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AALV;AAOU;EACE,WAAA;EACA,WAAA;EACA,mBA3CC;EA4CD,cAAA;EACA,kBAAA;EACA,gBAAA;AALZ;AAOY;EAEE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBArDD;EAsDC,kBAAA;EACA,gBAAA;AANd;AASY;EACE,SAAA;AAPd;AAUY;EACE,YAAA;AARd;AAYU;EACE,uBAAA;AAVZ;AAYY;EACE,wBAAA;EACA,MAAA;AAVd;AAaY;EACE,yBAAA;EACA,SAAA;AAXd;AA7CI;EA8DE,iDAAA;AAdN;AAgBM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAdR;AAgBQ;EACE,kBAAA;EACA,mBAAA;AAdV;AAgBU;EACE,cAAA;EACA,iBAAA;EACA,cAtGC;EAuGD,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAdZ;AAgBY;EACE,cA9GE;AAgGhB;AAAQ;EAkBE,iDAAA;AAfV;AAkBY;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAhBd;AAmBY;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;AAjBd;AAmBc;EACE,kBAAA;EACA,gBAAA;AAjBhB;AAmBgB;EACE,mBAAA;AAjBlB;AAqBc;EACE,cAAA;AAnBhB;;AA6BA,2DAAA;AAEA;EAEI;IACE,cAlKU;EAsId;EA+BE;IACE,cAAA;EA7BJ;AACF;AAiCA,sDAAA;AAEA;EAGM;IACE,aAAA;EAlCN;EAqCI;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,iBAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;IACA,gCAAA;IACA,yCAAA;EAnCN;EAqCM;IACE,gBAAA;IACA,gBAAA;EAnCR;EAsCM;IACE,WAAA;IACA,6BAAA;EApCR;EAsCQ;IACE,kBAAA;EApCV;EAwCU;IACE,WAAA;EAtCZ;EAyCU;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,UAAA;EAvCZ;EAyCY;IACE,kBAAA;EAvCd;EA0CY;IACE,cAAA;EAxCd;AACF;AAiDA,sDAAA;AAEA;EACE;IACE,kBAAA;EAhDF;AACF","sourcesContent":["@charset \"UTF-8\";\n/* ================= HEADER ================= */\n#header-wrap {\n  background: #e5eef0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n}\n#header-wrap .nav-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 15px 20px;\n}\n#header-wrap .nav-container nav {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* ================= MOBILE TOGGLE ================= */\n}\n#header-wrap .nav-container nav .nav-mobile {\n  display: none;\n}\n#header-wrap .nav-container nav .nav-mobile button {\n  width: 40px;\n  height: 40px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: relative;\n}\n#header-wrap .nav-container nav .nav-mobile button span {\n  width: 25px;\n  height: 3px;\n  background: #212121;\n  display: block;\n  position: relative;\n  transition: 0.3s;\n}\n#header-wrap .nav-container nav .nav-mobile button span::before, #header-wrap .nav-container nav .nav-mobile button span::after {\n  content: \"\";\n  width: 100%;\n  height: 3px;\n  background: #212121;\n  position: absolute;\n  transition: 0.3s;\n}\n#header-wrap .nav-container nav .nav-mobile button span::before {\n  top: -8px;\n}\n#header-wrap .nav-container nav .nav-mobile button span::after {\n  bottom: -8px;\n}\n#header-wrap .nav-container nav .nav-mobile button.active span {\n  background: transparent;\n}\n#header-wrap .nav-container nav .nav-mobile button.active span::before {\n  transform: rotate(45deg);\n  top: 0;\n}\n#header-wrap .nav-container nav .nav-mobile button.active span::after {\n  transform: rotate(-45deg);\n  bottom: 0;\n}\n#header-wrap .nav-container nav {\n  /* ================= NAV LIST ================= */\n}\n#header-wrap .nav-container nav .nav-list {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n  flex: 1;\n}\n#header-wrap .nav-container nav .nav-list li {\n  position: relative;\n  white-space: nowrap;\n}\n#header-wrap .nav-container nav .nav-list li a {\n  display: block;\n  padding: 8px 10px;\n  color: #212121;\n  font-weight: 800;\n  font-size: 15px;\n  text-decoration: none;\n  transition: 0.3s;\n}\n#header-wrap .nav-container nav .nav-list li a:hover {\n  color: #CFAB8D;\n}\n#header-wrap .nav-container nav .nav-list li {\n  /* ================= DROPDOWN ================= */\n}\n#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle > a::after {\n  content: \"▼\";\n  font-size: 10px;\n  margin-left: 5px;\n}\n#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0%;\n  min-width: 220px;\n  background: white;\n  list-style: none;\n  padding: 8px 0;\n  margin: 0;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 10000;\n}\n#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a {\n  padding: 12px 20px;\n  font-weight: 600;\n}\n#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a:hover {\n  background: #f5f5f5;\n}\n#header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown.show {\n  display: block;\n}\n\n/* ================= DESKTOP HOVER ONLY ================= */\n@media (min-width: 1135px) {\n  li.nav-dropdown-toggle:hover > a {\n    color: #CFAB8D;\n  }\n  li.nav-dropdown-toggle:hover .navbar-dropdown {\n    display: block;\n  }\n}\n/* ================= MOBILE STYLES ================= */\n@media (max-width: 1134px) {\n  #header-wrap .nav-container nav .nav-mobile {\n    display: flex;\n  }\n  #header-wrap .nav-container nav .nav-list {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    flex-direction: column;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n  #header-wrap .nav-container nav .nav-list.open {\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n  #header-wrap .nav-container nav .nav-list li {\n    width: 100%;\n    border-bottom: 1px solid #ddd;\n  }\n  #header-wrap .nav-container nav .nav-list li a {\n    padding: 12px 20px;\n  }\n  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle > a::after {\n    content: \"\";\n  }\n  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown {\n    position: static;\n    display: none;\n    background: #f5f5f5;\n    box-shadow: none;\n    padding: 0;\n  }\n  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown li a {\n    padding: 12px 40px;\n  }\n  #header-wrap .nav-container nav .nav-list li.nav-dropdown-toggle .navbar-dropdown.show {\n    display: block;\n  }\n}\n/* ================= SMALL DEVICES ================= */\n@media (max-width: 768px) {\n  #header-wrap .nav-container {\n    padding: 12px 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
